export default __webpack_public_path__ + "static/media/EniolaO.cc970bef.png";